import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';

import './RecommendationsEdit.css';

import backIcon from './../../image/back.png';

const RecommendationsEdit = ({ setCurrentPage, selectedRecommendation }) => {
    const [recommendationInfo, setRecommendationInfo] = useState([]);

    const [nameRu, setNameRu] = useState(null);
    const [nameEn, setNameEn] = useState(null);

    const [descriptionRu, setDescriptionRu] = useState(null);
    const [descriptionEn, setDescriptionEn] = useState(null);

    const [image, setImage] = useState(null);
    const [imageFile, setImageFile] = useState(null);

    const [endDate, setEndDate] = useState(null);
    const [newEndDate, setNewEndDate] = useState(null);
    const dateTimeRef = useRef(null);

    // нередактируемые поля
    const [address, setAddress] = useState(null);
    const [subcategory, setSubcategory] = useState(null);
    const [userName, setUserName] = useState(null);

    useEffect(() => {
        if (recommendationInfo.end) {
            setNewEndDate(formatDate(recommendationInfo.end));
        }
    }, [recommendationInfo.end]);

    useEffect(() => {
        console.log('recommendationInfo: ', recommendationInfo);
    }, [recommendationInfo]);

    // загрузка рекомендации
    useEffect(() => {
        const recommendationLoading = async () => {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/manage/ad',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                        params: {
                            id: selectedRecommendation.id,
                        },
                    }
                );
                if (response.data.success) {
                    console.log(response.data.result);
                    setRecommendationInfo(response.data.result);
                    setNameRu(response.data.result.nameRu);
                    setNameEn(response.data.result.nameEn);
                    setDescriptionRu(response.data.result.descriptionRu);
                    setDescriptionEn(response.data.result.descriptionEn);
                    setImage(response.data.result.image);
                    setEndDate(response.data.result.end);
                    setAddress(response.data.result.address);
                    setSubcategory(response.data.result.eventSubCategoryName);
                    setUserName(response.data.result.ownerName);
                }
            } catch (error) {
                console.error('Ошибка получения данных о рекомендации ', error);
            }
        };
        recommendationLoading();
    }, []);

    // клик назад
    const handleBackClick = () => {
        setCurrentPage('Recommendations');
    };

    // обработка картинки
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result);
                setImageFile(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    // открыть календарь
    const handleDateClick = () => {
        if (
            dateTimeRef.current &&
            typeof dateTimeRef.current.showPicker === 'function'
        ) {
            dateTimeRef.current.showPicker();
        }
    };

    // дата
    const handleDateChange = (e) => {
        setNewEndDate(e.target.value);
    };

    // форматирование даты
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const timezoneOffset = date.getTimezoneOffset();
        const localDate = new Date(date.getTime() - timezoneOffset * 60 * 1000);

        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const day = String(localDate.getDate()).padStart(2, '0');
        const hours = String(localDate.getHours()).padStart(2, '0');
        const minutes = String(localDate.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const handleStartClick = async () => {
        if (
            selectedRecommendation.status === 'Created' ||
            selectedRecommendation.status === 'Stop'
        ) {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/manage/ad/start',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                        params: {
                            id: recommendationInfo.id,
                        },
                    }
                );
                if (response.data.success) {
                    console.log('Рекомендация запущена');
                    setCurrentPage('Recommendations');
                }
            } catch (error) {
                console.error('Ошибка запуска рекомендации ', error);

                if (
                    error.response.data.error.message ===
                    'PAYMENT NOT CONFIRMED'
                ) {
                    alert(
                        'Для запуска необходимо подтвердить оплату рекомендации'
                    );
                }
            }
        }
    };

    const handleStopClick = async () => {
        if (selectedRecommendation.status === 'Show') {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/manage/ad/stop',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                        params: {
                            id: recommendationInfo.id,
                        },
                    }
                );
                if (response.data.success) {
                    console.log('Рекомендация остановлена');
                    setCurrentPage('Recommendations');
                }
            } catch (error) {
                console.error('Ошибка остановки рекомендации ', error);
            }
        }
    };

    const handleDeleteClick = async () => {
        const isConfirmed = window.confirm('Подтвердите удаление рекомендации');

        if (isConfirmed) {
            try {
                const response = await axios.get(
                    'https://mepointserver.ru/manage/ad/remove',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem(
                                'authToken'
                            )}`,
                        },
                        params: {
                            id: recommendationInfo.id,
                        },
                    }
                );
                if (response.data.success) {
                    console.log('Рекомендация удалена');
                    setCurrentPage('Recommendations');
                }
            } catch (error) {
                console.error('Ошибка удаления рекомендации ', error);
            }
        }
    };

    const handleSaveClick = async () => {
        try {
            const endDateUtc = new Date(newEndDate).toISOString();
            const response = await axios.post(
                'https://mepointserver.ru/manage/ad/update',
                {
                    id: recommendationInfo.id,
                    image: imageFile ? imageFile.split(';base64,')[1] : null,
                    nameRu: nameRu,
                    nameEn: nameEn,
                    descriptionRu: descriptionRu,
                    descriptionEn: descriptionEn,
                    end: endDateUtc,
                },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                }
            );

            if (response.data.success) {
                console.log('Рекомендация изменена');
                setCurrentPage('Recommendations');
            }
        } catch (error) {
            console.error('Ошибка редактирования рекомендации ', error);
        }
    };

    const handlePayClick = async () => {
        try {
            const response = await axios.get(
                'https://mepointserver.ru/manage/ad/payment/confirm',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'authToken'
                        )}`,
                    },
                    params: {
                        id: recommendationInfo.id,
                    },
                }
            );
            if (response.data.success) {
                alert('Оплата подтверждена');
            }
        } catch (error) {
            console.error('Ошибка подтверждения оплаты ', error);
        }
    };

    return (
        <div className='edit__wrapper'>
            <div className='edit__back' onClick={handleBackClick}>
                <img src={backIcon} alt='back' />
            </div>
            <h1 className='edit__title'>Редактировать реакомендацию</h1>
            <div className='edit__items'>
                <div className='edit__item_name'>
                    <h3>Название (Ru)</h3>
                    <input
                        type='text'
                        value={nameRu}
                        onChange={(e) => setNameRu(e.target.value)}
                    />
                </div>

                <div className='edit__item_name'>
                    <h3>Название (En)</h3>
                    <input
                        type='text'
                        value={nameEn}
                        onChange={(e) => setNameEn(e.target.value)}
                    />
                </div>

                <div className='edit__item_name'>
                    <h3>Описание (Ru)</h3>
                    <textarea
                        rows={3}
                        value={descriptionRu}
                        onChange={(e) => setDescriptionRu(e.target.value)}
                    ></textarea>
                </div>

                <div className='edit__item_name'>
                    <h3>Описание (En)</h3>
                    <textarea
                        rows={3}
                        value={descriptionEn}
                        onChange={(e) => setDescriptionEn(e.target.value)}
                    ></textarea>
                </div>

                <div className='edit__item_name disabled__input'>
                    <h3>Адрес</h3>
                    <input disabled value={address} />
                </div>

                <div className='edit__item_name disabled__input'>
                    <h3>Пользователь</h3>
                    <input disabled value={userName} />
                </div>

                <div className='edit__item_name disabled__input'>
                    <h3>Подкатегория</h3>
                    <input disabled value={subcategory} />
                </div>

                <div className='edit__item_name'>
                    <h3>Изображение</h3>
                    <div className='edit__image_items'>
                        <input
                            type='file'
                            accept='image/*'
                            onChange={handleImageChange}
                            className='image__change'
                            id='imageEdit'
                        />
                        <label htmlFor='imageEdit'>
                            <img
                                src={
                                    image && image.length < 400
                                        ? `https://mepointserver.ru${image}`
                                        : image
                                }
                                alt={image !== null && 'image'}
                            />
                        </label>
                    </div>
                </div>

                <div className='edit__item_name'>
                    <h3>Дата окончания</h3>
                    <input
                        value={newEndDate ? newEndDate : null}
                        type='datetime-local'
                        ref={dateTimeRef}
                        onClick={handleDateClick}
                        onChange={handleDateChange}
                    />
                </div>
            </div>

            <div className='recommend__btns'>
                <div
                    className='recommend__btn active'
                    onClick={handleSaveClick}
                >
                    Сохранить
                </div>
                <div
                    className={`recommend__btn ${
                        recommendationInfo.status === 'Created' ||
                        recommendationInfo.status === 'Stop'
                            ? 'active'
                            : ''
                    }`}
                    onClick={handleStartClick}
                >
                    Запустить
                </div>
                <div
                    className={`recommend__btn ${
                        recommendationInfo.status === 'Show' ? 'active' : ''
                    }`}
                    onClick={handleStopClick}
                >
                    Остановить
                </div>
                <div
                    className='recommend__btn active'
                    onClick={handleDeleteClick}
                >
                    Удалить
                </div>
                <div
                    className={`recommend__btn ${
                        recommendationInfo.paymentStatus &&
                        (recommendationInfo.paymentStatus === 'Wait' ||
                            recommendationInfo.paymentStatus === 'Canceled')
                            ? 'active'
                            : ''
                    }`}
                    onClick={handlePayClick}
                >
                    Оплачено
                </div>
            </div>
        </div>
    );
};

export default RecommendationsEdit;
